import {
  ApiPath,
  insentifKegiatanSchema,
  institutionSettingsSchema,
  type CreateInsentifKegiatanRequest,
  type InsentifKegiatanListQuery,
  type UpdateInsentifKegiatanRequest,
  type UpdateInstitutionSettingsRequest,
} from '@app/shared';
import { apiDelete, apiGet, apiList, apiPatch, apiPost, apiUpload } from '../../lib/api';

const INSTITUTION_PATH = '/settings/institution';
const INSENTIF_PATH = '/master/insentif-kegiatan';

export const getInstitutionSettings = () => apiGet(INSTITUTION_PATH, institutionSettingsSchema);
export const saveInstitutionSettings = (body: UpdateInstitutionSettingsRequest) =>
  apiPatch(INSTITUTION_PATH, body, institutionSettingsSchema);
/** Upload file logo lembaga (multipart/form-data, field "logo"). */
export const uploadInstitutionLogo = (file: File) => {
  const formData = new FormData();
  formData.append('logo', file);
  return apiUpload('PUT', `${INSTITUTION_PATH}/logo`, formData, institutionSettingsSchema);
};

export const getInsentifKegiatanList = (params?: InsentifKegiatanListQuery) =>
  apiList(
    INSENTIF_PATH,
    insentifKegiatanSchema,
    params as Record<string, string | number | boolean | undefined>,
  );
export const createInsentifKegiatan = (body: CreateInsentifKegiatanRequest) =>
  apiPost(INSENTIF_PATH, body, insentifKegiatanSchema);
export const updateInsentifKegiatan = (id: number, body: UpdateInsentifKegiatanRequest) =>
  apiPatch(`${INSENTIF_PATH}/${id}`, body, insentifKegiatanSchema);
export const deleteInsentifKegiatan = (id: number) => apiDelete(`${INSENTIF_PATH}/${id}`);

// Retain import to detect shared API-path breaking changes at build time.
void ApiPath;
